import { useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Row, Col, Table } from "react-bootstrap";
import { useToasts } from "react-toast-notifications";

import Head from "@/components/Content/Head";
import BasePagination from "@/components/Pagination/BasePagination";
import Fetching from "@/components/Fetching/Fetching";
import WebContentTableHead from "./WebContentTableHead";
import WebContentTableBody from "./WebContentTableBody";
import WebContentForm from "./WebContentForm/WebContentForm";
import classes from "../maintainers.module.scss";

import { useWebContentPaginate, useMutateWebContent } from "@/hooks/maintainers/web_contents";
import { base_list } from "./web_content.constants";

const WebContent = () => {
	const { addToast } = useToasts();
	const { search } = useSelector((state) => state.auth.filter);
	const { option } = useParams();

	const [base, setBase] = useState({ ...base_list });

	const { data, isLoading, isFetching } = useWebContentPaginate({
		...base,
		search,
	});
	const { mutate: mutateSave, isLoading: isLoadingSave } = useMutateWebContent({
		...base,
		search,
	});

	const { web_contents: list } = data ? data : {};
	const { data: web_contents, last_page, total, from, to } = list ? list : {};

	const confirmSave = (data) => {
		const data_send = { ...base, search, params: { ...data } };

		const formData = new FormData();
		formData.append("data", JSON.stringify(data_send) ? JSON.stringify(data_send) : "");
		if (data.url_media instanceof Blob) {
			formData.append("files[]", data.url_media, data.url_media.name);
		} else {
			formData.append("files[]", data.url_media);
		}

		data.details.forEach((detail, index) => {
			if (detail.media_url instanceof Blob) {
				formData.append(`detail_files[${index}]`, detail.media_url, detail.media_url.name);
			}
		});

		mutateSave(formData, {
			onSuccess: () => {
				addToast("Contenido Web guardado correctamente.", {
					appearance: "success",
				});
			},
		});
	};

	const setPage = (value) => setBase({ ...base, page: value });
	const setOrder = (value) => setBase({ ...base, order: value });
	const setOrderType = (value) => setBase({ ...base, orderType: value });
	const setPaginate = (value) => setBase({ ...base, paginate: value });

	if (isLoading) {
		return <Fetching />;
	}

	return (
		<>
			<Head title="Contenidos Web" button={false} back_url={"/mantenedores"} isFetching={isFetching} />

			<Row className={` ${classes.main_row}`}>
				<Col md={12} className={classes.main_col}>
					<Row className={classes.table}>
						<div className={classes.table_div}>
							<Table className={classes.table_desktop}>
								<WebContentTableHead order={base.order} setOrder={setOrder} orderType={base.orderType} setOrderType={setOrderType} />

								<WebContentTableBody web_contents={web_contents} />
							</Table>
						</div>
					</Row>

					<BasePagination
						page={base.page}
						paginate={base.paginate}
						last_page={last_page}
						quantity={total}
						from={from}
						to={to}
						setPage={setPage}
						setPaginate={setPaginate}
					/>
				</Col>
			</Row>

			{option && <WebContentForm confirmSave={confirmSave} isLoadingSave={isLoadingSave} />}
		</>
	);
};

export default WebContent;
